var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { property } from 'lit/decorators.js';
import Localization from './localization.js';
export const withLocalization = (superclass) => {
    class WithLocalization extends superclass {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
        constructor(...args) {
            super();
            this.loc = Localization.getInstance();
            window.addEventListener('languageChanged', () => {
                this.requestUpdate();
            });
        }
        localization(key, ...interpolations) {
            if (this.loc.loaded) {
                return this.loc.get(this.tagName, key, ...interpolations);
            }
            return '';
        }
        localizationOrDefault(key, defaultValue, ...interpolations) {
            if (this.loc.loaded) {
                return this.loc.getOrDefault(this.tagName, key, defaultValue, ...interpolations);
            }
            return defaultValue;
        }
    }
    __decorate([
        property({ type: Localization })
    ], WithLocalization.prototype, "loc", void 0);
    return WithLocalization;
};
